import { CHECKOUT_UPDATE_TYPE, checkoutModalActionType } from 'redux/actions/modalsActions';
import { generateModalActionType } from 'redux/utils/modal';

const defaultState = {
    isOpen: false,
    downPayment: null,
    type: 'full',
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case generateModalActionType('show', checkoutModalActionType):
            return {
                ...state,
                isOpen: true,
            };
        case generateModalActionType('hide', checkoutModalActionType):
            return {
                ...state,
                isOpen: false,
            };
        case CHECKOUT_UPDATE_TYPE:
            return {
                ...state,
                type: action.payload.type,
                downPayment: action.payload.downPayment,
            };
        default:
            return {
                ...state,
            };
    }
};
